import * as actionTypes from 'redux/actions/actionTypes'

const defaultSettings = {
  videoResolutionDisplay: 'high',
}

const settingsReducer = (state = defaultSettings, action) => {
  switch (action.type) {
    case actionTypes.SET_VIDEO_RESOLUTION_DISPLAY: {
      return {
        ...state,
        videoResolutionDisplay: action.payload.videoResolutionDisplay,
      }
    }
    default:
      return state
  }
}

export default settingsReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/settingsReducer.js